/**
 * Reducer for Multi-part question tutorials. Triggers a new multi-part
 * question tutorial if the user starts multi-part question with more than
 * one part
 */

import { fromJS } from 'immutable';
import log from 'loglevel';

import {
    MULTI_PART_QUESTION_TUTORIAL_DISMISSED,
    TRIGGER_MULTI_PART_QUESTION_TUTORIAL,
} from '../tutorial-actions/multi-part-question';
import { SET_TUTORIALS_COMPLETED, RESET_TUTORIALS } from '../actions';

export const MULTI_PART_QUESTION_TUTORIAL_KEY = 'multiPartQuestionTutorial';

const INITIAL_STATE = fromJS({
    completed: false,
    active: false,
    state: null,
});

export function multiPartQuestionTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;

        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(MULTI_PART_QUESTION_TUTORIAL_KEY) !== -1) {
                return fromJS({
                    completed: true,
                    active: false,
                    state: null,
                });
            }
            break;

        // When a multi-part answer screen is loaded if there is more than
        // one part:
        case TRIGGER_MULTI_PART_QUESTION_TUTORIAL:
            return triggerMultipartQuestionTutorial(state, action);

        // When user has viewed the tutorial, but not yet completed the
        // question:
        case MULTI_PART_QUESTION_TUTORIAL_DISMISSED:
            return state.set('active', false);
    }

    return state;
}

/**
 * Trigger the tutorial if not already completed
 * @param state
 * @param action
 * @return {*}
 */
function triggerMultipartQuestionTutorial(state, action) {
    if (!state.get('completed')) {
        log.debug('Multipart question tutorial triggered', action);

        return fromJS({
            completed: false,
            active: true,
            state: {
                attemptId: action.attemptId,
            },
        });
    }
    return state;
}
